import { useQuery } from '@tanstack/react-query';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';

// general structure of the query keys that should probably work for most cases
export const userKeys = {
  all: ['users'],
  users: () => [...userKeys.all],
  user: (id) => [...userKeys.users(), id],
  userSettings: (id) => ['settings', id]
};


export const useUsersQuery = () => {
  const api = useAPI();
  const usersQuery = useQuery(userKeys.users(), createQueryRequest(api.core.getUsers));
  return usersQuery;
};

export const useUserQuery = (id) => {
  const api = useAPI();
  const userQuery = useQuery({
    queryKey: userKeys.user(id),
    queryFn: createQueryRequest(api.core.getUser),
    enabled: !!id
  });
  return userQuery;
};

export const useUserSettingsQuery = (id) => {
  const api = useAPI();
  const userSettingsQuery = useQuery({
    queryKey: userKeys.userSettings(id),
    queryFn: createQueryRequest(api.core.getUserSettings, id),
    enabled: !!id
  });
  return userSettingsQuery;
};
